import { ErrorSidePanel } from '@/components/errors';
import { templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useGetUsers } from './-hooks/get-users.hook';
import { type UsersProps } from './-model/props';
import { UsersLight } from './-skins';

export const Route = createFileRoute('/(services)/services/_sheet/users/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const { data, isLoading } = useGetUsers();
  const navigate = useNavigate();
  const users = data ?? [];
  const props: UsersProps = {
    users,
    loading: isLoading,
    onAddUser: () => void navigate({ to: '/services/users/add' }),
    onSelectUser: (userId) => void navigate({ to: '/services/users/$userId', params: { userId } }),
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: UsersProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <UsersLight {...props} />,
  };
}
